export const COUNTRY_OPTIONS = [
  { value: 'AF', text: 'AF - Afghanistan' },
  { value: 'AL', text: 'AL - Albania' },
  { value: 'DZ', text: 'DZ - Algeria' },
  { value: 'AD', text: 'AD - Andorra' },
  { value: 'AO', text: 'AO - Angola' },
  { value: 'AG', text: 'AG - Antigua and Barbuda' },
  { value: 'AR', text: 'AR - Argentina' },
  { value: 'AM', text: 'AM - Armenia' },
  { value: 'AU', text: 'AU - Australia' },
  { value: 'AT', text: 'AT - Austria' },
  { value: 'AZ', text: 'AZ - Azerbaijan' },
  { value: 'BS', text: 'BS - Bahamas' },
  { value: 'BH', text: 'BH - Bahrain' },
  { value: 'BD', text: 'BD - Bangladesh' },
  { value: 'BB', text: 'BB - Barbados' },
  { value: 'BY', text: 'BY - Belarus' },
  { value: 'BE', text: 'BE - Belgium' },
  { value: 'BZ', text: 'BZ - Belize' },
  { value: 'BJ', text: 'BJ - Benin' },
  { value: 'BT', text: 'BT - Bhutan' },
  { value: 'BO', text: 'BO - Bolivia' },
  { value: 'BA', text: 'BA - Bosnia and Herzegovina' },
  { value: 'BW', text: 'BW - Botswana' },
  { value: 'BR', text: 'BR - Brazil' },
  { value: 'BN', text: 'BN - Brunei' },
  { value: 'BG', text: 'BG - Bulgaria' },
  { value: 'BF', text: 'BF - Burkina Faso' },
  { value: 'BI', text: 'BI - Burundi' },
  { value: 'CV', text: 'CV - Cabo Verde' },
  { value: 'KH', text: 'KH - Cambodia' },
  { value: 'CM', text: 'CM - Cameroon' },
  { value: 'CA', text: 'CA - Canada' },
  { value: 'CF', text: 'CF - Central African Republic' },
  { value: 'TD', text: 'TD - Chad' },
  { value: 'CL', text: 'CL - Chile' },
  { value: 'CN', text: 'CN - China' },
  { value: 'CO', text: 'CO - Colombia' },
  { value: 'KM', text: 'KM - Comoros' },
  { value: 'CG', text: 'CG - Congo' },
  { value: 'CD', text: 'CD - Congo (DRC)' },
  { value: 'CR', text: 'CR - Costa Rica' },
  { value: 'CI', text: 'CI - Cote d\'Ivoire' },
  { value: 'HR', text: 'HR - Croatia' },
  { value: 'CU', text: 'CU - Cuba' },
  { value: 'CY', text: 'CY - Cyprus' },
  { value: 'CZ', text: 'CZ - Czech Republic' },
  { value: 'DK', text: 'DK - Denmark' },
  { value: 'DJ', text: 'DJ - Djibouti' },
  { value: 'DM', text: 'DM - Dominica' },
  { value: 'DO', text: 'DO - Dominican Republic' },
  { value: 'EC', text: 'EC - Ecuador' },
  { value: 'EG', text: 'EG - Egypt' },
  { value: 'SV', text: 'SV - El Salvador' },
  { value: 'GQ', text: 'GQ - Equatorial Guinea' },
  { value: 'ER', text: 'ER - Eritrea' },
  { value: 'EE', text: 'EE - Estonia' },
  { value: 'SZ', text: 'SZ - Eswatini' },
  { value: 'ET', text: 'ET - Ethiopia' },
  { value: 'FJ', text: 'FJ - Fiji' },
  { value: 'FI', text: 'FI - Finland' },
  { value: 'FR', text: 'FR - France' },
  { value: 'GA', text: 'GA - Gabon' },
  { value: 'GM', text: 'GM - Gambia' },
  { value: 'GE', text: 'GE - Georgia' },
  { value: 'DE', text: 'DE - Germany' },
  { value: 'GH', text: 'GH - Ghana' },
  { value: 'GR', text: 'GR - Greece' },
  { value: 'GD', text: 'GD - Grenada' },
  { value: 'GT', text: 'GT - Guatemala' },
  { value: 'GN', text: 'GN - Guinea' },
  { value: 'GW', text: 'GW - Guinea-Bissau' },
  { value: 'GY', text: 'GY - Guyana' },
  { value: 'HT', text: 'HT - Haiti' },
  { value: 'HN', text: 'HN - Honduras' },
  { value: 'HU', text: 'HU - Hungary' },
  { value: 'IS', text: 'IS - Iceland' },
  { value: 'IN', text: 'IN - India' },
  { value: 'ID', text: 'ID - Indonesia' },
  { value: 'IR', text: 'IR - Iran' },
  { value: 'IQ', text: 'IQ - Iraq' },
  { value: 'IE', text: 'IE - Ireland' },
  { value: 'IL', text: 'IL - Israel' },
  { value: 'IT', text: 'IT - Italy' },
  { value: 'JM', text: 'JM - Jamaica' },
  { value: 'JP', text: 'JP - Japan' },
  { value: 'JO', text: 'JO - Jordan' },
  { value: 'KZ', text: 'KZ - Kazakhstan' },
  { value: 'KE', text: 'KE - Kenya' },
  { value: 'KI', text: 'KI - Kiribati' },
  { value: 'KP', text: 'KP - Korea (North)' },
  { value: 'KR', text: 'KR - Korea (South)' },
  { value: 'KW', text: 'KW - Kuwait' },
  { value: 'KG', text: 'KG - Kyrgyzstan' },
  { value: 'LA', text: 'LA - Laos' },
  { value: 'LV', text: 'LV - Latvia' },
  { value: 'LB', text: 'LB - Lebanon' },
  { value: 'LS', text: 'LS - Lesotho' },
  { value: 'LR', text: 'LR - Liberia' },
  { value: 'LY', text: 'LY - Libya' },
  { value: 'LI', text: 'LI - Liechtenstein' },
  { value: 'LT', text: 'LT - Lithuania' },
  { value: 'LU', text: 'LU - Luxembourg' },
  { value: 'MG', text: 'MG - Madagascar' },
  { value: 'MW', text: 'MW - Malawi' },
  { value: 'MY', text: 'MY - Malaysia' },
  { value: 'MV', text: 'MV - Maldives' },
  { value: 'ML', text: 'ML - Mali' },
  { value: 'MT', text: 'MT - Malta' },
  { value: 'MH', text: 'MH - Marshall Islands' },
  { value: 'MR', text: 'MR - Mauritania' },
  { value: 'MU', text: 'MU - Mauritius' },
  { value: 'MX', text: 'MX - Mexico' },
  { value: 'FM', text: 'FM - Micronesia' },
  { value: 'MD', text: 'MD - Moldova' },
  { value: 'MC', text: 'MC - Monaco' },
  { value: 'MN', text: 'MN - Mongolia' },
  { value: 'ME', text: 'ME - Montenegro' },
  { value: 'MA', text: 'MA - Morocco' },
  { value: 'MZ', text: 'MZ - Mozambique' },
  { value: 'MM', text: 'MM - Myanmar' },
  { value: 'NA', text: 'NA - Namibia' },
  { value: 'NR', text: 'NR - Nauru' },
  { value: 'NP', text: 'NP - Nepal' },
  { value: 'NL', text: 'NL - Netherlands' },
  { value: 'NZ', text: 'NZ - New Zealand' },
  { value: 'NI', text: 'NI - Nicaragua' },
  { value: 'NE', text: 'NE - Niger' },
  { value: 'NG', text: 'NG - Nigeria' },
  { value: 'MK', text: 'MK - North Macedonia' },
  { value: 'NO', text: 'NO - Norway' },
  { value: 'OM', text: 'OM - Oman' },
  { value: 'PK', text: 'PK - Pakistan' },
  { value: 'PW', text: 'PW - Palau' },
  { value: 'PA', text: 'PA - Panama' },
  { value: 'PG', text: 'PG - Papua New Guinea' },
  { value: 'PY', text: 'PY - Paraguay' },
  { value: 'PE', text: 'PE - Peru' },
  { value: 'PH', text: 'PH - Philippines' },
  { value: 'PL', text: 'PL - Poland' },
  { value: 'PT', text: 'PT - Portugal' },
  { value: 'QA', text: 'QA - Qatar' },
  { value: 'RO', text: 'RO - Romania' },
  { value: 'RU', text: 'RU - Russia' },
  { value: 'RW', text: 'RW - Rwanda' },
  { value: 'KN', text: 'KN - Saint Kitts and Nevis' },
  { value: 'LC', text: 'LC - Saint Lucia' },
  { value: 'VC', text: 'VC - Saint Vincent and the Grenadines' },
  { value: 'WS', text: 'WS - Samoa' },
  { value: 'SM', text: 'SM - San Marino' },
  { value: 'ST', text: 'ST - Sao Tome and Principe' },
  { value: 'SA', text: 'SA - Saudi Arabia' },
  { value: 'SN', text: 'SN - Senegal' },
  { value: 'RS', text: 'RS - Serbia' },
  { value: 'SC', text: 'SC - Seychelles' },
  { value: 'SL', text: 'SL - Sierra Leone' },
  { value: 'SG', text: 'SG - Singapore' },
  { value: 'SK', text: 'SK - Slovakia' },
  { value: 'SI', text: 'SI - Slovenia' },
  { value: 'SB', text: 'SB - Solomon Islands' },
  { value: 'SO', text: 'SO - Somalia' },
  { value: 'ZA', text: 'ZA - South Africa' },
  { value: 'SS', text: 'SS - South Sudan' },
  { value: 'ES', text: 'ES - Spain' },
  { value: 'LK', text: 'LK - Sri Lanka' },
  { value: 'SD', text: 'SD - Sudan' },
  { value: 'SR', text: 'SR - Suriname' },
  { value: 'SE', text: 'SE - Sweden' },
  { value: 'CH', text: 'CH - Switzerland' },
  { value: 'SY', text: 'SY - Syria' },
  { value: 'TW', text: 'TW - Taiwan' },
  { value: 'TJ', text: 'TJ - Tajikistan' },
  { value: 'TZ', text: 'TZ - Tanzania' },
  { value: 'TH', text: 'TH - Thailand' },
  { value: 'TL', text: 'TL - Timor-Leste' },
  { value: 'TG', text: 'TG - Togo' },
  { value: 'TO', text: 'TO - Tonga' },
  { value: 'TT', text: 'TT - Trinidad and Tobago' },
  { value: 'TN', text: 'TN - Tunisia' },
  { value: 'TR', text: 'TR - Turkey' },
  { value: 'TM', text: 'TM - Turkmenistan' },
  { value: 'TV', text: 'TV - Tuvalu' },
  { value: 'UG', text: 'UG - Uganda' },
  { value: 'UA', text: 'UA - Ukraine' },
  { value: 'AE', text: 'AE - United Arab Emirates' },
  { value: 'GB', text: 'GB - United Kingdom' },
  { value: 'US', text: 'US - United States' },
  { value: 'UY', text: 'UY - Uruguay' },
  { value: 'UZ', text: 'UZ - Uzbekistan' },
  { value: 'VU', text: 'VU - Vanuatu' },
  { value: 'VE', text: 'VE - Venezuela' },
  { value: 'VN', text: 'VN - Vietnam' },
  { value: 'YE', text: 'YE - Yemen' },
  { value: 'ZM', text: 'ZM - Zambia' },
  { value: 'ZW', text: 'ZW - Zimbabwe' }
]
